import React, { useState } from 'react';

import useClassy from '@core/hooks/useClassy';

import Icon from '@ui/Icon';

import classes from './style.module.scss';

interface GroupProps {
  children: React.ReactNode;
  label: string;
}

const Group = ({ children, label }: GroupProps) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const bem = useClassy(classes, 'Sidebar');

  return (
    <div className={bem('-nav-group', 'rm-Sidebar-nav-group')}>
      <button
        className={bem('Sidebar-nav-group-toggle', 'rm-Sidebar-nav-group-toggle')}
        onClick={() => setIsExpanded(!isExpanded)}
        type="button"
      >
        {label}
        <Icon aria-hidden="true" className={bem('-link-icon')} name={isExpanded ? 'chevron-down' : 'chevron-right'} />
      </button>
      {!!isExpanded && <ul className={bem('Sidebar-nav-group-list', 'rm-Sidebar-nav-group-list')}>{children}</ul>}
    </div>
  );
};

export default Group;
